// Состояние приложения: одно изменяемое хранилище на всё SPA.

import type { DashboardDefinition, DashboardSummary, DataQueryResponse, EmissCatalogItem, EmissCatalogStatus, EmissInspection, EmissStatus, Indicator, IndicatorDimension, IndicatorSection, Territory, UserPreferences, VisualizationType, WidgetDefinition, WorldBankCatalogItem, WorldBankCatalogStatus } from '../types';

import { blankDashboard } from './model';
import { initialPreferences } from './preferences';

export type DashboardSourceType = 'bdmo' | 'worldbank' | 'emiss' | 'settlements';

/** Мои — свои; Общие — public и шаблоны; Все — администратору, с чужими личными. */
export type DashboardManagerTab = 'mine' | 'shared' | 'all';

export type AutoWidgetRole = 'kpi' | 'map' | 'trend' | 'rank' | 'matrix' | 'table';

export type AutoIndicatorChoiceKind = 'local' | 'emiss_catalog' | 'worldbank_catalog';

export type AutoIndicatorChoice = {
  key: string;
  sourceType: DashboardSourceType;
  kind: AutoIndicatorChoiceKind;
  indicatorId: string;
  localIndicatorId: string | null;
  title: string;
  subtitle: string;
  unit: string;
  indicator?: Indicator;
  emissItem?: EmissCatalogItem;
  worldBankItem?: WorldBankCatalogItem;
};

export type AutoWidgetDraft = {
  role: AutoWidgetRole;
  indicator: Indicator;
  visualization: VisualizationType;
  layout: WidgetDefinition['layout'];
  territoryIds: string[];
  years: number[];
  dimensions: Record<string, string[]>;
};

export type AppState = {
  indicators: Indicator[];
  indicatorSections: IndicatorSection[];
  territories: Territory[];
  localTerritories: Territory[];
  catalogTerritories: Territory[];
  dimensions: IndicatorDimension[];
  indicatorRequestToken: number;
  catalogRequestToken: number;
  sectionRequestToken: number;
  autoBuilderRequestToken: number;
  dashboards: DashboardSummary[];
  currentDashboardId: string | null;
  currentTemplateId: string | null;
  definition: DashboardDefinition;
  editingWidgetId: string | null;
  inspectorVisualization: VisualizationType | null;
  dirty: boolean;
  suppressGridEvents: boolean;
  suppressInspectorEvents: boolean;
  layoutEditing: boolean;
  viewMode: boolean;
  filtersOpen: boolean;
  sourcesMenuOpen: boolean;
  builderOpen: boolean;
  paletteOpen: boolean;
  renderVersions: Map<string, number>;
  renderEpoch: number;
  dataCache: Map<string, DataQueryResponse>;
  visualCompactModes: Map<string, boolean>;
  emissInspection: EmissInspection | null;
  emissStatus: EmissStatus | null;
  emissCatalogStatus: EmissCatalogStatus | null;
  emissCatalogResults: EmissCatalogItem[];
  leftEmissCatalogResults: EmissCatalogItem[];
  worldBankCatalogStatus: WorldBankCatalogStatus | null;
  worldBankCatalogResults: WorldBankCatalogItem[];
  autoSections: IndicatorSection[];
  autoIndicatorChoices: AutoIndicatorChoice[];
  autoSelectedIndicatorKeys: Set<string>;
  autoBdmoDistricts: Territory[];
  autoBdmoRegions: Territory[];
  autoBdmoMunicipalities: Territory[];
  pendingDashboardDeleteId: string | null;
  dashboardManagerTab: DashboardManagerTab;
  preferences: UserPreferences;
};

export const state: AppState = {
  indicators: [],
  indicatorSections: [],
  territories: [],
  localTerritories: [],
  catalogTerritories: [],
  dimensions: [],
  indicatorRequestToken: 0,
  catalogRequestToken: 0,
  sectionRequestToken: 0,
  autoBuilderRequestToken: 0,
  dashboards: [],
  currentDashboardId: null,
  currentTemplateId: null,
  definition: blankDashboard('Новый дашборд'),
  editingWidgetId: null,
  inspectorVisualization: null,
  dirty: false,
  suppressGridEvents: false,
  suppressInspectorEvents: false,
  layoutEditing: true,
  viewMode: false,
  filtersOpen: false,
  sourcesMenuOpen: false,
  builderOpen: false,
  paletteOpen: true,
  renderVersions: new Map(),
  renderEpoch: 0,
  dataCache: new Map(),
  visualCompactModes: new Map(),
  emissInspection: null,
  emissStatus: null,
  emissCatalogStatus: null,
  emissCatalogResults: [],
  leftEmissCatalogResults: [],
  worldBankCatalogStatus: null,
  worldBankCatalogResults: [],
  autoSections: [],
  autoIndicatorChoices: [],
  autoSelectedIndicatorKeys: new Set(),
  autoBdmoDistricts: [],
  autoBdmoRegions: [],
  autoBdmoMunicipalities: [],
  pendingDashboardDeleteId: null,
  dashboardManagerTab: 'mine',
  preferences: initialPreferences,
};
